module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic-ext78.251d36f.woff2";